// Adapted from TdApi in member app. Is different b/c it makes ajax calls directly to admin app (not API).
// Also handles the conversion of underscores to camel case in response keys
// TODO do we want to use API and screenflow?

import { ajax } from 'rxjs/ajax';
import { catchError, map } from 'rxjs/operators';
import Qs from 'qs';
import _ from 'lodash';
import TeladocErrors from './TeladocErrors';
import { mapKeysDeep } from './lodashUtils';
import { camelizeKey, underscoreKey } from './utils';

const HEADERS = {
  Accept:         'application/json',
  'Content-Type': 'application/json',
  ...window.TELADOC_ENVELOP
};

const stringifyParams = (params) =>
  Qs.stringify(params, { arrayFormat: 'brackets' });

export const buildUrl = (url, params = null) => {
  if (params) {
    const paramsUnderscored = mapKeysDeep(params, underscoreKey);
    const urlParams = `?${stringifyParams(paramsUnderscored)}`;
    return `${url}${urlParams}`;
  }
  return url;
};

const TdAjax = {
  upload(url, file = null) {
    const data = new FormData();
    data.append('file', file);
    const headers = {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      ...window.TELADOC_ENVELOP
    };

    return ajax({
      url: `${buildUrl(url)}`,
      method: "POST",
      headers: headers,
      contentType: false,
      processData: false,
      body: data
    });
  },

  post(url, body = null) {
    const headers = _.merge(HEADERS, {
      'X-CSRF-Token' : $('meta[name="csrf-token"]').attr('content')
    });

    return ajax({
      url: `${buildUrl(url)}`,
      method: "POST",
      headers: headers,
      body: body
    });
  },

  put(url, body = null) {
    const headers = _.merge(HEADERS, {
      'X-CSRF-Token' : $('meta[name="csrf-token"]').attr('content')
    });

    return ajax({
      url: `${buildUrl(url)}`,
      method: "PUT",
      headers: headers,
      body: body
    });
  },

  delete(url, body = null) {
    const headers = _.merge(HEADERS, {
      'X-CSRF-Token' : $('meta[name="csrf-token"]').attr('content')
    });

    return ajax({
      url: `${buildUrl(url)}`,
      method: "DELETE",
      headers: headers,
      body: body
    });
  },

  get(url, params = null) {
    return ajax({
      url:         `${buildUrl(url, params)}`,
      crossDomain: true,
      headers:     HEADERS,
      body:        params
    }).pipe(
      catchError(xhr => {
        throw new TeladocErrors(xhr);
      }),
      map(payload => {
        if (payload.error) {
          // some error handling error
          throw new TeladocErrors(payload);
        }
        const data = payload.response;
        // convert to camel case
        return mapKeysDeep(data, camelizeKey);
      }));
  }
};

export { TdAjax };
